import React from "react";

import themesConstantsBase from "./styles/Base";
import themesConstantsAccelix from "./styles/Accelix";
import { themeConstants, responsiveConstants } from "./Constants";
import Button from "../widgets/buttons";

const StyleAccelix = themesConstantsAccelix;
const StyleBase = themesConstantsBase;
const StylethemeConstants = themeConstants;

export * from "./Constants";
export const themes = (params = themeConstants.THEME_BASE) => {
  switch (params) {
    case StylethemeConstants.THEME_ACCELIX:
      return StyleAccelix;
    case StylethemeConstants.THEME_BASE:
      return StyleBase;
    default:
      return StyleBase;
  }
};

export const ThemeContext = React.createContext({
  themeName: themeConstants.THEME_BASE,
  styles: StyleBase,
  toggleTheme: () => {}
});

export const ThemeTogglerButton = () => {
  return (
    <ThemeContext.Consumer>
      {({ toggleTheme }) => (
        <div>
          <Button primary handleOnClick={toggleTheme}>
            Toggle Theme
          </Button>
          <Button handleOnClick={toggleTheme}>Toggle Theme</Button>
        </div>
      )}
    </ThemeContext.Consumer>
  );
};

export const ResponsiveContext = React.createContext({
  screenFormatId: responsiveConstants.DESKTOP
});

export const withResponsive = Comp => props => (
  <ResponsiveContext.Consumer>
    {screenFormatId => <Comp screenFormatId={screenFormatId} {...props} />}
  </ResponsiveContext.Consumer>
);

export const debounce = (func, delay) => {
  let inDebounce;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(inDebounce);
    inDebounce = setTimeout(() => func.apply(context, args), delay);
  };
};
